/* jshint esversion: 6 */
/* jshint esversion: 11 */
/* jshint ignore:start */
import React, { useContext, useEffect, useRef } from 'react';
import { MyContext } from '../Context/MyProvider';
import secureLocalStorage from 'react-secure-storage';

const PayStack = ({ Amount, attributes }) => {

    const { setPaymentRes, setPaymentLoading } = useContext(MyContext);

    const OpenRef = useRef(false);

    const handlePayment = () => {
        OpenRef.current = true;

        const localData = secureLocalStorage.getItem("LoginData");

        if (!localData && OpenRef.current) return;

        const parsedData = JSON.parse(localData);

        secureLocalStorage.setItem("Amount", Amount);

        const script = document.createElement("script");
        script.src = "https://js.paystack.co/v1/inline.js";
        script.async = true;
        script.onload = () => {
            const paymentHandler = window.PaystackPop.setup({
                key: attributes?.split(",")[0],
                email: parsedData.email,
                amount: Amount * 100,
                currency: "NGN",
                callback: (response) => {
                    setPaymentRes("PaymentDone");
                    sessionStorage.setItem("transactionid", response.transaction);
                },
                onClose: () => {
                    setPaymentRes("PaymentFaild");

                },
            });
            paymentHandler.openIframe();
        };
        document.body.appendChild(script);
    };

    useEffect(() => {
        setPaymentLoading(false);
        if (Amount && !OpenRef.current) {
            handlePayment();
        }
    }, [Amount, attributes])

    return null;
}

export default PayStack
/* jshint ignore:end */